import { render } from "./CreditReportNamibia.vue?vue&type=template&id=44d0f3af"
import script from "./CreditReportNamibia.vue?vue&type=script&lang=js"
export * from "./CreditReportNamibia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__